import { Multistep } from '@/components/multistep/Multistep';
import { Step } from '@/components/multistep/Questionnaire';
import { Page } from '@/layouts/Page';
import { CSVProvider } from '@/services/csv/CSVService';

import { IssuesStep } from '@/pages/product/product/bulk/steps/IssuesStep';
import { RateCardUploadStep } from './RateCardUploadStep';
import { RateCardReviewStep } from './RateCardReviewStep';

export default function RateCardBulkUpload() {
  return (
    <Page className="mx-auto flex w-full max-w-6xl flex-col bg-opacity-100 p-12 py-14">
      <div className="border-secondary-std mb-4 border-b pb-4">
        <h1 className="text-4xl font-bold">Import Rate Cards (CSV)</h1>
        <p>Upload a spreadsheet of rate cards to bulk import them into the system.</p>
      </div>
      <CSVProvider>
        <Multistep>
          <RateCardUploadStep />
          <Step
            id="issues"
            title="Issues"
            description="There were some issues with parsing or validating the spreadsheet. Please resolve them and reupload the spreadsheet."
            controls="manual"
          >
            <IssuesStep />
          </Step>
          <Step
            id="review"
            title="Review Uploads"
            description="Please review the rate cards below and press upload to import them."
            controls="manual"
          >
            <RateCardReviewStep />
          </Step>
        </Multistep>
      </CSVProvider>
    </Page>
  );
}
